export default "__VITE_ASSET__DX$V_FYO__"